import styled from 'styled-components';
import { BREAKPOINTS } from '../../utils/responsive';

/**
 * A container that is positioned absolutely over the map.
 *
 * The `placement` prop is a string that can include any of the following:
 * - `top`
 * - `bottom`
 * - `left`
 * - `right`
 * - `middle` (horizontal)
 *
 * For example: `placement="top left"` would position the container in the top left corner.
 *
 * The "top right" placement has some special handling to avoid map controls.
 *
 * Also, `z-index` defautls to 1000, but can be overridden with the zIndex prop.
 */
const PositionedOverMap = styled.div`
  display: flex;

  margin: 8px;
  @media (min-width: ${BREAKPOINTS.md}) {
    margin: 16px;
  }

  position: absolute;
  ${({ placement }) => (placement.includes('top') ? 'top: 0;' : '')}
  ${({ placement }) => (placement.includes('bottom') ? 'bottom: 0;' : '')}
  ${({ placement }) => (placement.includes('left') ? 'left: 0;' : '')}
  ${({ placement }) => (placement.includes('right') ? 'right: 0;' : '')}
  ${({ placement }) =>
    placement.includes('middle')
      ? `
      left: 0;
      right: 0;
      width: fit-content;
      margin-left: auto !important;
      margin-right: auto !important;
      justify-content: center;
      text-align: center;
  `
      : ''}

  /* for top right, avoid map controls: */
  ${({ placement }) =>
    placement.includes('top') && placement.includes('right')
      ? 'margin-top: 10px !important; margin-right: 50px !important;'
      : ''}

  ${({ zIndex }) => `z-index: ${zIndex ?? 1000};`}
`;

export default PositionedOverMap;
